import React, { Component } from 'react';
import Button from 'react-bootstrap-button-loader';
import { connect } from 'react-redux';
import { show } from 'redux-modal';
import UploadPopup from '../jobs/UploadPopup';


class AddJobButtons extends Component {
  showJobUpload() {
    const { dispatch, account } = this.props;
    if (account.uuid) {
      dispatch(show('UploadJobsPopModal', { account }));
    }
  }

  render() {
    return(
      <div className="add-jobs-nav">
        <Button disabled>Upload XML Feed</Button>
        <Button onClick={this.showJobUpload.bind(this)}>Upload File</Button>
        <Button disabled>Add Manually</Button>
        <UploadPopup />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {

    return {};
}

export default connect(mapStateToProps)(AddJobButtons);